import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios'
import { Http } from '../http'
import { IHttpClient } from './IHttpClient'

/**
 * Legacy HTTP Client - Direct routing to original Atta APIs
 */
export class LegacyHttpClient implements IHttpClient {
	private httpClient: AxiosInstance

	constructor(baseUrl: string, headers?: any) {
		this.httpClient = Http.create(baseUrl, headers)
	}

	get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.httpClient.get<T, R>(url, config)
	}

	post<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
		return this.httpClient.post<T, R>(url, data, config)
	}

	put<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
		return this.httpClient.put<T, R>(url, data, config)
	}

	delete<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.httpClient.delete<T, R>(url, config)
	}

	patch<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
		return this.httpClient.patch<T, R>(url, data, config)
	}

	get defaults() {
		return this.httpClient.defaults
	}

	get interceptors() {
		return this.httpClient.interceptors
	}
}
